import ActivitiesView from "@components/order/components/activity/ActivitiesView";
import AppContext from "@helpers/context";
import UserAPI from "@network/api/user";
import { Notifications } from "d-react-components";
import { map } from "lodash";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";

const UserDetailDashboard = () => {
  const { user } = useContext(AppContext);
  const { t } = useTranslation();
  const activityList = useRef(null);

  const source = (paging: any) => {
    const body = { id: user?.id };
    return UserAPI.activityList(paging, body);
  };

  const transformer = (res: any) => {
    const activityList = res?.data?.data?.activities ?? [];
    return map(activityList, (item) => ({
      ...item,
      files: map(item.attachment, (attItem) => attItem?.attachment),
    }));
  };

  const onClickSendComment = (comment: any, attachment: any) => {
    const body = {
      id: user?.id,
      comment,
      attachment: map(attachment, (item) => item?.key),
    };
    return UserAPI.activityAdd(body).then(() => {
      Notifications.showSuccess(t("addCommentSuccess"));
    });
  };

  return (
    <ActivitiesView
      hideType
      source={source}
      transformer={transformer}
      setRef={(listRefParams: any) => (activityList.current = listRefParams)}
      onClickSendComment={onClickSendComment}
      isInstantUploadAttach
    />
  );
};

export default UserDetailDashboard;
